import { createAsyncAction } from "typesafe-actions";
import adConstants from "./ad.constants";
import { Ad } from "./interfaces";

const { FETCH_ADD_REQUEST, FETCH_ADD_SUCCESS, FETCH_ADD_FAILED } = adConstants;

export const fetchAd = createAsyncAction(FETCH_ADD_REQUEST, FETCH_ADD_SUCCESS, FETCH_ADD_FAILED)<
    string,
    Ad,
    ErrorHandler
>();
